import { useSearchParams } from 'react-router-dom';
import Header from '@/components/Header';
import Footer from '@/components/Footer';

const GuidelinePackSingleCardPage = () => {
  const [searchParams] = useSearchParams();
  const isMobile = searchParams.get('isMobile') === '1' || searchParams.get('isMobile') === 'true';

  return (
    <div className="w-full bg-white min-h-screen flex flex-col">
      {!isMobile && <Header />}
      
      <div className="w-full bg-white inline-flex justify-center overflow-hidden">
        <div className="container pt-10 pb-20 px-4 md:px-0 flex flex-col justify-start items-start gap-[60px] overflow-hidden">
          <div className="w-full flex flex-col justify-start items-start gap-2.5">
            <div className="justify-center text-black text-[40px] font-bold leading-[60px]">シングルカードの梱包方法</div>
            <div className="h-[3px] w-full relative bg-[#e4e4e4]" />
            <div className="w-full justify-center text-black text-base font-normal leading-7">
              シングルカードは素材の特性上破損しやすいため、厳重な梱包をお願いしております。<br/>
              出品者様から当社へ商品を発送いただく際は、輸送中に破れ・折れなどの損傷が発生しないよう、以下の手順に沿った梱包・発送をお願いいたします。<br/>
              ※なお、出品画像では確認できなかった破れ・折れ等のダメージが検品時に判明した場合、取引がキャンセルとなる可能性がありますので、あらかじめご了承ください。
            </div>
          </div>
          
          <div className="self-stretch flex flex-col justify-start items-start gap-[30px]">
            <div className="px-[5px] inline-flex justify-start items-center gap-2.5">
              <div className="w-0 h-[27.50px] border-[#e4e4e4] border-2 rounded-xl" />
              <div className="justify-center text-black text-2xl font-bold leading-9">梱包方法</div>
            </div>
            
            <div className="flex flex-col justify-start items-start gap-[30px]">
              {/* Step 1: スリーブに入れる */}
              <div className="w-full flex flex-row justify-start items-start gap-2.5">
                <div className="w-1/2 py-5 flex flex-col justify-start items-start gap-2.5">
                  <div className="justify-center text-black text-xl font-bold leading-[30px]">1. スリーブに入れる</div>
                  <div className="self-stretch pl-5 flex justify-center items-center gap-2.5">
                    <div className="flex-1 justify-center text-black text-base font-normal leading-7">
                      カードは必ずスリーブ（プラスチック素材のソフトケース）に入れてから梱包してください。<br/>
                      商品をスリーブに入れずに直接硬質ケースへ収納すると、カード表面に傷がつく恐れがあります。
                    </div>
                  </div>
                </div>
                <div className="w-1/2">
                  <img className="w-full h-auto" src="/images/terms/guideline_pack_single_card_1.jpg" alt="スリーブに入れる" />
                </div>
              </div>
              
              {/* Step 2: 硬質ケースにいれる */}
              <div className="w-full flex flex-row justify-start items-start gap-2.5">
                <div className="w-1/2 py-5 flex flex-col justify-start items-start gap-2.5">
                  <div className="justify-center text-black text-xl font-bold leading-[30px]">2. 硬質ケースにいれる</div>
                  <div className="self-stretch pl-5 flex justify-start items-center gap-2.5">
                    <div className="flex-1 justify-center text-black text-base font-normal leading-7">
                      スリーブに入れた状態で、さらにプラスチック製の硬質ケースにお入れください。
                    </div>
                  </div>
                </div>
                <div className="w-1/2">
                  <img className="w-full h-auto" src="/images/terms/guideline_pack_single_card_2.jpg" alt="硬質ケースにいれる" />
                </div>
              </div>
              
              {/* Step 3: 緩衝材を利用する */}
              <div className="w-full flex flex-row justify-start items-start gap-2.5">
                <div className="w-1/2 py-5 flex flex-col justify-start items-start gap-2.5">
                  <div className="justify-center text-black text-xl font-bold leading-[30px]">3. 緩衝材を利用する</div>
                  <div className="self-stretch pl-5 flex justify-start items-center gap-2.5">
                    <div className="flex-1 justify-center text-black text-base font-normal leading-7">
                      硬質ケースに入れた商品を、さらに緩衝材等で包むように梱包してください。
                    </div>
                  </div>
                </div>
                <div className="w-1/2">
                  <img className="w-full h-auto" src="/images/terms/guideline_pack_single_card_3.jpg" alt="緩衝材を利用する" />
                </div>
              </div>
              
              {/* Step 4: 適切なサイズの梱包材を利用する */}
              <div className="w-full flex flex-col justify-start items-start gap-2.5">
                <div className="justify-center text-black text-xl font-bold leading-[30px]">4. 適切なサイズの梱包材を利用する</div>
                <div className="self-stretch px-5 flex flex-col justify-start items-start gap-2.5">
                  <div className="self-stretch justify-center text-black text-base font-normal leading-7">
                    商品のサイズに合った適切な梱包材をご使用のうえ、発送をお願いいたします。<br/>
                    梱包材はダンボール以外の素材でも問題ございません。
                  </div>
                  <div className="self-stretch flex flex-row justify-start items-start gap-5">
                    <div className="flex-1">
                      <img className="w-full h-auto" src="/images/terms/guideline_pack_single_card_4.jpg" alt="適切なサイズの梱包材1" />
                    </div>
                    <div className="flex-1">
                      <img className="w-full h-auto" src="/images/terms/guideline_pack_single_card_5.jpg" alt="適切なサイズの梱包材2" />
                    </div>
                  </div>
                </div>
              </div>
              
              {/* Step 5: 取引IDを貼付 */}
              <div className="w-full flex flex-col justify-start items-start gap-2.5">
                <div className="justify-center text-black text-xl font-bold leading-[30px]">5. 各カードに取引IDを記載した付箋等を貼付する</div>
                <div className="self-stretch pl-5 flex justify-start items-center gap-2.5">
                  <div className="flex-1 justify-center text-black text-base font-normal leading-7">
                    複数の取引商品を同梱して発送する場合は、取引IDを記載した付箋や紙（跡が残らないもの）を、カード一つひとつに貼付してください。<br/>
                    各商品に取引IDが貼付されていない場合は、事務局の判断で商品状態にあわせて取引に紐付けをおこないます。事務局で判断が難しい場合は、確認のご連絡をいたします。
                  </div>
                </div>
              </div>
              
              {/* Step 6: テープで閉じて発送 */}
              <div className="w-full flex flex-col justify-start items-start gap-2.5">
                <div className="justify-center text-black text-xl font-bold leading-[30px]">6. 梱包材の封入部をテープでしっかり閉じて発送する</div>
                <div className="self-stretch pl-5 flex justify-start items-center gap-2.5">
                  <div className="flex-1 justify-center text-black text-base font-normal leading-7">
                    宅急便コンパクトなどの組み立て式梱包材や、レターパックなど封入部に粘着テープが備わっている梱包材をご利用の場合でも、封入部は必ず別途テープでしっかりと留めてください。<br/>
                    これは、梱包材の強度を高め、輸送中のダメージから商品を守るための重要な対応となります。<br/>
                    安全な配送のため、ご理解とご協力をお願いいたします。
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      {!isMobile && <Footer />}
    </div>
  );
};

export default GuidelinePackSingleCardPage;